<template>
  <li>
    <div class="row">
      <router-link tag="a" :to="{ name: 'admins.profile.show', params: { id: admin.id }}">
        <div class="flex flex-row align-center justify-start col-xs-12 col-md-10">
          <div class="details">
            <h3 class="mb-0">{{ admin.name }}</h3>
          </div>
          <div>
            <span class="label label-info py-10">{{ admin.role }}</span>
          </div>
          <div v-if="$vlastMode && admin.activation_notified_at" >(Activation Email Sent: {{ admin.activation_notified_at | dateTimezone( $user.timezone, $user.date_format_preference, true, true) }})</div>
        </div>
        <button
          class="btn btn-lg btn-success btn-job-complete"
          v-if="!admin.deleted_at && $userIsRestrictedAdmin">
          <template>View</template>
        </button>
      </router-link>
      <div class="col-xs-12 col-md-2">
        <ladda-button
          class="btn btn-lg btn-danger btn-job-complete"
          :click="handleDeleteAdminCallback"
          v-if="!admin.deleted_at && $userIsAdmin && !$userIsRestrictedAdmin">
          <template><i class="fa fa-trash"></i> Delete User</template>
        </ladda-button>
        <div
          class="btn btn-danger-outline btn-block btn-not-clickable truncate"
          v-if="admin.deleted_at">
          Deleted
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapActions } from 'vuex'
import { alert, notify } from 'utils'

export default {
  props: {
    admin: {
      required: true,
      type: Object
    }
  },

  methods: {
    ...mapActions('admin', ['deleteAdmin']),

    handleDeleteAdminCallback () {
      return alert.confirm({
        title: 'Delete Admin Account',
        text: 'Are you sure you want to continue and delete the account?',
        buttons: {
          confirm: {
            text: 'Yes, delete account.'
          }
        }
      }).then(() => {
        return this.deleteAdmin({id: this.admin.id}).catch(error => {
          if (error.response.status === 400) {
            notify.error(error.response.data.message)
          } else {
            notify.error('Sorry something went wrong, please refresh the page and try again.')
          }
        })
      })
    }
  }
}
</script>
